import { render, staticRenderFns } from "./addCustomSelf.vue?vue&type=template&id=6532e09d&"
import script from "./addCustomSelf.vue?vue&type=script&lang=ts&"
export * from "./addCustomSelf.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports